/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Button, Layout, Select } from 'antd';
import { useStore } from './store';
import Notification from './components/notification';

import './cyber-security-training.less';
import './cyber-security-training.mobile.less';
import HomeOutlined from '@ant-design/icons/lib/icons/HomeOutlined';
import { useNavigate, useParams } from 'react-router';
import { useLocation } from 'react-router-dom';
import GA4React from 'ga-4-react';
import { PENDING_COURSES, civilPath } from './constants';
import useGAPageview from '../../hooks/useGAPageview';

interface IPageHeaderProps {
  noHomeButton?: boolean;
}

const PageHeader: React.FunctionComponent<IPageHeaderProps> = (props) => {
  const location = useLocation();
  useGAPageview();
  const { language, page, switchLanguage } = useStore();
  const [isShow, setIsShow] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const changeUrlLanguage = (url: string, targetLanguage: string) => {
    if (url.includes('/en/')) {
      url = url.replace('/en/', `/${targetLanguage}/`);
    } else if (url.includes('/tc/')) {
      url = url.replace('/tc/', `/${targetLanguage}/`);
    } else if (url.includes('/sc')) {
      url = url.replace('/sc/', `/${targetLanguage}/`);
    }
    // console.log(url, targetLanguage, 'targetLanguage');
    return url;
  };

  const changeLanguage = (code: any) => {
    let url = window.location.href;
    if (!window.location.href.includes('/civil/')) {
      navigate(civilPath(code));
    } else if (window.location.href.includes('/civil/')) {
      let targetLangage = code;
      let course = params.course ?? '';
      let isPendingCourses = PENDING_COURSES.includes(course) && code === 'sc';
      targetLangage = isPendingCourses ? 'tc' : code;
      if (isPendingCourses) {
        setIsShow(true);
        setTimeout(() => {
          setIsShow(false);
        }, 5000);
        return;
      } else {
        window.location.href = changeUrlLanguage(url, targetLangage);
      }
    }
  };
  const gotoHome = () => {
    navigate(civilPath(language));
  };
  useEffect(() => {
    if (
      process.env.REACT_APP_HOST_TYPE !== 'prod' &&
      !document.title.includes(`[${process.env.REACT_APP_HOST_TYPE}]`)
    ) {
      document.title = `[${process.env.REACT_APP_HOST_TYPE}] ${document.title}`;
    }
    const currentLocation = window.location.href;
    if (currentLocation.includes('/en')) {
      switchLanguage('en');
    } else if (currentLocation.includes('/tc')) {
      switchLanguage('tc');
    } else if (currentLocation.includes('/sc')) {
      switchLanguage('sc');
    } else {
      switchLanguage('tc');
    }
  }, [location]);

  useEffect(() => {
    console.log(process.env);
  }, []);
  return (
    <Layout.Header className="page-header">
      {process.env.REACT_APP_DOMAIN !== 'cpttm' ? (
        <>
          <div className="logo">&nbsp;</div>
          <div className="divider" />
          <div className="page-title-container">
            <div className="page-title">{page?.pageHeader?.pageTitleEN}</div>
            <div className="page-title">{page?.pageHeader?.pageTitleCN}</div>
            <div className="page-title">{page?.pageHeader?.pageTitleSC}</div>
          </div>
          <div className={`logo ${process.env.REACT_APP_DOMAIN} hide`}>
            &nbsp;
          </div>
        </>
      ) : (
        <div className="logo-cpttm"></div>
      )}
      <div className="right">
        {props.noHomeButton !== undefined && props.noHomeButton ? null : (
          <Button className="home-button" type="text" onClick={gotoHome}>
            <HomeOutlined />
          </Button>
        )}
        <Select
          value={language}
          bordered={false}
          onSelect={changeLanguage}
          className="language-switch"
        >
          <Select.Option value="tc">繁</Select.Option>
          <Select.Option value="sc">简</Select.Option>
          <Select.Option value="en">EN</Select.Option>
        </Select>
      </div>
      {isShow && (
        <Notification
          message={`${
            language === 'tc'
              ? '抱歉，这个培训目前只提供繁体中文和英文'
              : 'Sorry, this training is currently only available in Traditional Chinese and English'
          }`}
        />
      )}
    </Layout.Header>
  );
};

export default PageHeader;
